import styled from 'styled-components'

function BaseFirstPageIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" fill="currentColor" />
    </svg>
  )
}

export const FirstPageIcon = styled(BaseFirstPageIcon)`
  flex-shrink: 0;
`
